import React from "react";
import { Clock, DollarSign, TrendingUp, Heart } from "lucide-react";

const ResultsSection = () => {
  const results = [
    {
      icon: Clock,
      number: "60–100",
      label: "Hours Saved",
      description: "Monthly time savings through automation"
    },
    {
      icon: DollarSign,
      number: "£2,000–£6,000",
      label: "Monthly Cost Savings",
      description: "Reduction in marketing and operational costs"
    },
    {
      icon: TrendingUp,
      number: "20%-40%",
      label: "Revenue Increase",
      description: "Average revenue boost for our clients"
    },
    {
      icon: Heart,
      number: "15%–30%",
      label: "Customer Satisfaction Increase",
      description: "Improved client experience and retention"
    }
  ];

  return (
    <section className="py-20 bg-black">
      <div className="container mx-auto px-6">
        {/* Section Title */}
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
            Proven Results with{" "}
            <span className="text-transparent bg-gradient-to-r from-yellow-400 to-yellow-600 bg-clip-text">
              Smart Marketing
            </span>
          </h2>
        </div>

        {/* Results Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {results.map((result, index) => {
            const IconComponent = result.icon;
            return (
              <div
                key={index}
                className="text-center bg-gray-900/50 backdrop-blur-sm border border-gray-700 rounded-lg p-8 hover:border-yellow-400 transition-all duration-300 transform hover:scale-105 group"
              >
                {/* Icon */}
                <div className="w-16 h-16 mx-auto mb-4 bg-gradient-to-r from-yellow-400 to-yellow-600 rounded-full flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                  <IconComponent className="w-8 h-8 text-black" />
                </div>
                
                {/* Number */}
                <h3 className="text-3xl md:text-4xl font-bold text-white mb-2 group-hover:text-yellow-400 transition-colors">
                  {result.number}
                </h3>
                
                {/* Label */}
                <h4 className="text-lg font-semibold text-yellow-400 mb-3">
                  {result.label}
                </h4>
                
                {/* Description */}
                <p className="text-gray-400 text-sm leading-relaxed">
                  {result.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ResultsSection;